export enum ContactUpdateEnum {
  Add,
  Delete,
}
